<script lang="ts" setup>

</script>

<template>
  <div class="table-empty">
    <i class="empty-icon" />
    <div class="empty-text">暂无持仓数据</div>
  </div>
</template>

<style scoped lang="scss">
.table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 44px;
  .empty-icon {
    display: inline-block;
    width: 310px;
    height: 112px;
    background: url('~@/assets/images/holdings/empty.svg') no-repeat;
    background-size: 100% 100%;
  }
  .empty-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1D2129;
    text-align: center;
    font-style: normal;
    text-transform: none;
    padding-top: 24px;
  }
}
</style>